/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Unit for `duration`
 */
export const SpaProductDurationDTO = {
    DAYS: 'DAYS',
    MINUTES: 'MINUTES'
} as const;
export type SpaProductDurationDTO = typeof SpaProductDurationDTO[keyof typeof SpaProductDurationDTO];

